import { Component, OnInit } from '@angular/core';
import { IdentityService } from 'src/app/security/identity.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-my-profile-incomplete',
  templateUrl: './my-profile-incomplete.component.html',
  styleUrls: ['./my-profile-incomplete.component.scss']
})
export class MyProfileIncompleteComponent implements OnInit {
  public loading = true;
  public profileCompleted$: Observable<boolean>;
  constructor(public identityService: IdentityService) {}

  public ngOnInit(): void {
    this.profileCompleted$ = this.identityService.userProfileComplete$.pipe(
      tap(() => (this.loading = false))
    );
  }
}
